import { ActionTypes as action } from "./action-types";
import tenantConfigService from "../../../api/tenantConfigService";

const actions = {

    async getMasterConfigList({ commit }) {
        const data = await tenantConfigService.getMasterConfigList();
        commit(action.GET_MASTER_SETTING_LIST, data);
        return
    },
    async getDefaultEmailTemplates({ commit }) {
        const data = await tenantConfigService.getDefaultEmailTemplates();
        const defaultTemplate = data ? data["default_email_templates"] : []
        commit(action.GET_DEFAULT_TEMPLATE_LIST, defaultTemplate);
        return
    },
    async getTenantConfigList({ commit, state }, isTenantSwitch = false) {
        if (!state.tenantList.length || isTenantSwitch) {
            const data = await tenantConfigService.getTenantConfigList();
            commit(action.GET_TENANT_LIST, data);
        }
        return
    },
    async getUpdatedTenantConfigList({ commit }) {
        const data = await tenantConfigService.getUpdatedTenantConfigList();
        commit(action.GET_TENANT_LIST, data);
        return
    },
    async getTenantConfigById({ commit }, id) {
        const data = await tenantConfigService.getTenantConfigById(id);
        commit(action.GET_TENANT_BY_ID, data);
        return
    },
    async updateTenentConfigValue({ commit }, data) {
        commit('updateTenentConfigValue', data);
    },
    async createTenantConfig({ dispatch }, data) {
        try {
            await tenantConfigService.createTenantConfig(data);
            await dispatch('getUpdatedTenantConfigList')
            return
        }
        catch (error) {
            console.log(error)
        }

    },
    async updateTenantConfig({ dispatch }, data) {
        await tenantConfigService.updateTenantConfig(data);
        await dispatch('getUpdatedTenantConfigList')
        return
    },
    async deleteTenantConfig({ commit }, id) {
        await tenantConfigService.deleteTenantConfig(id);
        return
    },
    async createLandingPageWallpaper({ dispatch }, data) {
        const result = await tenantConfigService.createLandingPageWallpaper(data);
        return result
    },
    async deleteLandingPageWallpaper({ }, id) {
        const result = await tenantConfigService.deleteLandingPageWallpaper(id);
        return result
    },
    resetState({ commit }) {
        commit(action.RESET_STATE);
    },
    async updateEmailTemplate({ dispatch }, data) {
        await tenantConfigService.updateEmailTemplate(data);
        await dispatch('getUpdatedTenantConfigList')
        return
    },
    async deleteEmailTemplate({ dispatch }, params) {
        await tenantConfigService.deleteEmailTemplate(params);
        await dispatch('getUpdatedTenantConfigList')
    },
    async getTenantNamesHistory({ commit }) {
        const data = await tenantConfigService.getTenantNamesHistory();
        return data
    },

};

export default actions;
